// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  background: #0C0907;
  padding: 10px 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
 
nav .wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 56px;
}
 
.navlinks {
  display: flex;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
}
 
.navlinks a {
  color: #F6EEE6;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.25s ease;
  white-space: nowrap;
}
 
.navlinks a:hover {
  color: #EE5B43;
}
 
.navbar-brand-text {
  color: #EE5B43;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.3px;
  white-space: nowrap;
}
 
/* ── ≥ 1501px ── */
@media (min-width: 1850px) {
  nav .wrap {
    max-width: 2000px;
    padding: 0 140px;
  }
}
 
/* ── ≤ 1024px ── */
@media (max-width: 1024px) {
  nav .wrap {
    padding: 0 32px;
    gap: 16px;
  }
 
  .navlinks {
    gap: 20px;
  }
}
 
/* ── ≤ 880px ── */
@media (max-width: 880px) {
  nav .wrap {
    padding: 10px 24px;
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 10px;
  }
 
  .navlinks {
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
    order: 2;
    flex: 1 1 100%;
    margin-top: 4px;
  }
 
  .navbar-brand-text {
    order: 1;
    font-size: 14px;
  }
}
 
/* ── ≤ 600px ── */
@media (max-width: 600px) {
  nav {
    padding: 8px 0;
  }
 
  nav .wrap {
    padding: 8px 16px;
  }
 
  .navlinks {
    gap: 12px;
  }
 
  .navlinks a {
    font-size: 12.5px;
  }
 
  .navbar-brand-text {
    font-size: 13px;
  }
}
 
/* ── ≤ 420px ── */
@media (max-width: 420px) {
  .navlinks {
    gap: 9px;
  }
 
  .navlinks a {
    font-size: 11px;
  }
 
  .navbar-brand-text {
    font-size: 11.5px;
  }
}
 
/* ── Scroll margin ── */
#precision,
#vigilance,
#particuliers,
#professionnels,
#alertes,
#apropos {
  scroll-margin-top: 76px;
}
 
@media (min-width: 1850px) {
  #precision,
  #vigilance,
  #particuliers,
  #professionnels,
  #alertes,
  #apropos {
    scroll-margin-top: 76px;
  }
}
 
@media (max-width: 1024px) {
  #precision,
  #vigilance,
  #particuliers,
  #professionnels,
  #alertes,
  #apropos {
    scroll-margin-top: 72px;
  }
}
 
@media (max-width: 880px) {
  #precision,
  #vigilance,
  #particuliers,
  #professionnels,
  #alertes,
  #apropos {
    scroll-margin-top: 132px;
  }
}
 
@media (max-width: 600px) {
  #precision,
  #vigilance,
  #particuliers,
  #professionnels,
  #alertes,
  #apropos {
    scroll-margin-top: 118px;
  }
}
 
@media (max-width: 420px) {
  #precision,
  #vigilance,
  #particuliers,
  #professionnels,
  #alertes,
  #apropos {
    scroll-margin-top: 112px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;;;;;;EAME,uBAAuB;AACzB;;AAEA;EACE;;;;;;IAME,uBAAuB;EACzB;AACF;;AAEA;EACE;;;;;;IAME,uBAAuB;EACzB;AACF;;AAEA;EACE;;;;;;IAME,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;;IAME,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;;IAME,wBAAwB;EAC1B;AACF","sourcesContent":["nav {\n  background: #0C0907;\n  padding: 10px 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n \nnav .wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 0 56px;\n}\n \n.navlinks {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  flex-wrap: wrap;\n}\n \n.navlinks a {\n  color: #F6EEE6;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.25s ease;\n  white-space: nowrap;\n}\n \n.navlinks a:hover {\n  color: #EE5B43;\n}\n \n.navbar-brand-text {\n  color: #EE5B43;\n  font-weight: 700;\n  font-size: 15px;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n \n/* ── ≥ 1501px ── */\n@media (min-width: 1850px) {\n  nav .wrap {\n    max-width: 2000px;\n    padding: 0 140px;\n  }\n}\n \n/* ── ≤ 1024px ── */\n@media (max-width: 1024px) {\n  nav .wrap {\n    padding: 0 32px;\n    gap: 16px;\n  }\n \n  .navlinks {\n    gap: 20px;\n  }\n}\n \n/* ── ≤ 880px ── */\n@media (max-width: 880px) {\n  nav .wrap {\n    padding: 10px 24px;\n    flex-wrap: wrap;\n    justify-content: center;\n    row-gap: 10px;\n  }\n \n  .navlinks {\n    gap: 16px;\n    flex-wrap: wrap;\n    justify-content: center;\n    order: 2;\n    flex: 1 1 100%;\n    margin-top: 4px;\n  }\n \n  .navbar-brand-text {\n    order: 1;\n    font-size: 14px;\n  }\n}\n \n/* ── ≤ 600px ── */\n@media (max-width: 600px) {\n  nav {\n    padding: 8px 0;\n  }\n \n  nav .wrap {\n    padding: 8px 16px;\n  }\n \n  .navlinks {\n    gap: 12px;\n  }\n \n  .navlinks a {\n    font-size: 12.5px;\n  }\n \n  .navbar-brand-text {\n    font-size: 13px;\n  }\n}\n \n/* ── ≤ 420px ── */\n@media (max-width: 420px) {\n  .navlinks {\n    gap: 9px;\n  }\n \n  .navlinks a {\n    font-size: 11px;\n  }\n \n  .navbar-brand-text {\n    font-size: 11.5px;\n  }\n}\n \n/* ── Scroll margin ── */\n#precision,\n#vigilance,\n#particuliers,\n#professionnels,\n#alertes,\n#apropos {\n  scroll-margin-top: 76px;\n}\n \n@media (min-width: 1850px) {\n  #precision,\n  #vigilance,\n  #particuliers,\n  #professionnels,\n  #alertes,\n  #apropos {\n    scroll-margin-top: 76px;\n  }\n}\n \n@media (max-width: 1024px) {\n  #precision,\n  #vigilance,\n  #particuliers,\n  #professionnels,\n  #alertes,\n  #apropos {\n    scroll-margin-top: 72px;\n  }\n}\n \n@media (max-width: 880px) {\n  #precision,\n  #vigilance,\n  #particuliers,\n  #professionnels,\n  #alertes,\n  #apropos {\n    scroll-margin-top: 132px;\n  }\n}\n \n@media (max-width: 600px) {\n  #precision,\n  #vigilance,\n  #particuliers,\n  #professionnels,\n  #alertes,\n  #apropos {\n    scroll-margin-top: 118px;\n  }\n}\n \n@media (max-width: 420px) {\n  #precision,\n  #vigilance,\n  #particuliers,\n  #professionnels,\n  #alertes,\n  #apropos {\n    scroll-margin-top: 112px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
